import { PrimaryButton, Text } from "@certn/cascadia-react";
import { useAllowStripe3dsOverlay } from "@certn/utils";
import { css } from "@emotion/css";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { Layout } from "@stripe/stripe-js";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useStripePaymentContext } from "./StripePaymentContext";

export function CheckoutForm() {
  useAllowStripe3dsOverlay();
  const { setStartPaymentState } = useStripePaymentContext();
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<null | string>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const redirectUrl = setStartPaymentState();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: redirectUrl.href,
      },
    });
    if (error) {
      setErrorMessage(error.message || "An unexpected error occurred.");
    }
  };

  const options = {
    layout: "tabs" as Layout,
  };
  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <PaymentElement options={options} />
      {errorMessage && <Text style="form/body-secondary">{errorMessage}</Text>}
      <PrimaryButton type="submit" isDisabled={!stripe} fullWidth>
        {t("Pay now")}
      </PrimaryButton>
    </form>
  );
}

const styles = {
  form: css({
    display: "flex",
    flexDirection: "column",
    gap: 16,
  }),
};
